var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#BDEECF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3948 91.0741C61.036 92.4282 62.7477 93.6659 64.5 94.8739C66.2561 93.6819 67.9594 92.4141 69.6052 91.0741C72.3488 88.8213 74.9307 86.3787 77.3321 83.7643C82.8679 77.7111 88.875 68.9361 88.875 59.0859C88.875 55.885 88.2445 52.7153 87.0196 49.758C85.7946 46.8007 83.9992 44.1136 81.7357 41.8502C79.4723 39.5868 76.7852 37.7913 73.8279 36.5664C70.8706 35.3414 67.701 34.7109 64.5 34.7109C61.299 34.7109 58.1294 35.3414 55.1721 36.5664C52.2148 37.7913 49.5277 39.5868 47.2643 41.8502C45.0008 44.1136 43.2054 46.8007 41.9804 49.758C40.7555 52.7153 40.125 55.885 40.125 59.0859C40.125 68.9361 46.1321 77.7084 51.6679 83.7643C54.0692 86.3797 56.6512 88.8205 59.3948 91.0741ZM64.5 67.888C62.1655 67.888 59.9267 66.9607 58.276 65.3099C56.6253 63.6592 55.6979 61.4204 55.6979 59.0859C55.6979 56.7515 56.6253 54.5126 58.276 52.8619C59.9267 51.2112 62.1655 50.2839 64.5 50.2839C66.8345 50.2839 69.0733 51.2112 70.724 52.8619C72.3747 54.5126 73.3021 56.7515 73.3021 59.0859C73.3021 61.4204 72.3747 63.6592 70.724 65.3099C69.0733 66.9607 66.8345 67.888 64.5 67.888Z",
    fill: "#16342E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f2870facbd5ba25ec8906310ebe0fa0e.svg";
export { ForwardRef as ReactComponent };